module.exports = __webpack_public_path__ + "static/media/vue.e1ea82cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/vue.png
// module id = 211
// module chunks = 0